module.exports = __webpack_public_path__ + "static/logoinverted-9512df0c63e2a3d7436be44b7807e899.svg";